import {SET_USER_PROFILE_PICTURE} from '../actions/users-profile-actions-types';

const INITIAL_USER_PROFILE_PICTURE_STATE = { result: '' }

export function setUserProfilePictureReducer(state = INITIAL_USER_PROFILE_PICTURE_STATE, action) {
    switch (action.type) {
        case SET_USER_PROFILE_PICTURE:
            return { result: action.payload }
        default:
            return state;
    }
}